import { render, staticRenderFns } from "./ShipmentDetailContainer.vue?vue&type=template&id=9445e2c8&"
import script from "./ShipmentDetailContainer.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports